export enum GivingType{
  Offering = "Offering",
  Tithes = "Tithes",
  Seeds = "Seeds",
  BuildingForm = "Building Offering",
  Vows = "Vows"
}
